/**
 * 直播来源页。claim 时写进 URL（`?from=`），结束页据此决定「返回角色列表」回哪。
 *
 * 走 URL 而不是内存 store：结束页存在刷新 / Safari 强杀后重进的场景，
 * 那时 store 已空但结束页仍会渲染（见 LiveSession 的 shouldRedirectToList 分支），
 * 只有 URL 上的信息还在。与 `?avatar_id=` 同样的理由。
 */

/** 来源 key → 返回路径。白名单固定，避免把 URL 上的任意字符串直接交给 router。 */
const LIVE_RETURN_PATH_BY_ORIGIN = {
  'vidu-stream': '/vidu-stream/avatar',
  home: '/home',
} as const;

export type LiveReturnOrigin = keyof typeof LIVE_RETURN_PATH_BY_ORIGIN;

/** 老链接 / 手改 URL / 深链没带 from 时的兜底，与改动前的行为一致。 */
const DEFAULT_LIVE_RETURN_PATH = LIVE_RETURN_PATH_BY_ORIGIN['vidu-stream'];

export const LIVE_RETURN_ORIGIN_PARAM = 'from';

function isLiveReturnOrigin(value: string): value is LiveReturnOrigin {
  return Object.hasOwn(LIVE_RETURN_PATH_BY_ORIGIN, value);
}

/** 把 URL 上的 `from` 解析成返回路径；未知值一律兜底，不透传给 router。 */
export function resolveLiveReturnPath(rawOrigin: string | null | undefined): string {
  const origin = rawOrigin?.trim() ?? '';
  if (!origin || !isLiveReturnOrigin(origin)) {
    return DEFAULT_LIVE_RETURN_PATH;
  }

  return LIVE_RETURN_PATH_BY_ORIGIN[origin];
}

/**
 * 来源页 → stream_element_click 的 click_position 值。
 * 跟随仓库惯例用下划线（`vidu_stream`、`s`、`home`）。
 */
const LIVE_ENTRY_CLICK_POSITION: Record<LiveReturnOrigin, string> = {
  'vidu-stream': 'vidu_stream',
  home: 'home',
};

export function getLiveEntryClickPosition(origin: LiveReturnOrigin): string {
  return LIVE_ENTRY_CLICK_POSITION[origin];
}
